import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Cookie } from 'lucide-react';

const CookieConsent: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [countryCode, setCountryCode] = useState<string>('');

  useEffect(() => {
    // Check if consent was already given
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      // Get user's country
      fetch('https://api.country.is')
        .then(res => res.json())
        .then(data => {
          setCountryCode(data.country);
          setIsVisible(true);
        })
        .catch(() => {
          // If country detection fails, show default EU-compliant notice
          setCountryCode('EU');
          setIsVisible(true);
        });
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  // Get appropriate message based on country
  const getMessage = () => {
    switch(countryCode) {
      case 'GB':
        return "We use essential cookies to ensure our website works properly. No tracking, just the basics!";
      case 'US':
        return "This site uses essential cookies to function. Your privacy matters to us!";
      default: // EU and others
        return "This website uses only essential cookies that are necessary for the website to function properly.";
    }
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: "spring", stiffness: 260, damping: 20 }}
          className="fixed bottom-4 right-4 z-50 max-w-sm bg-white rounded-lg shadow-lg border border-gray-200 p-4"
        >
          <div className="flex items-start gap-3">
            <Cookie className="w-6 h-6 text-primary flex-shrink-0" />
            <div className="flex-1">
              <p className="text-sm text-gray-600 mb-3">{getMessage()}</p>
              <div className="text-xs text-gray-500 mb-4">
                Read our{' '}
                <Link to="/privacy-policy" className="text-primary hover:text-primary-dark underline">
                  Privacy Policy
                </Link>
                {' '}and{' '}
                <Link to="/terms-conditions" className="text-primary hover:text-primary-dark underline">
                  Terms & Conditions
                </Link>
              </div>
              <button
                onClick={acceptCookies}
                className="bg-primary hover:bg-primary-dark text-white text-sm font-semibold py-2 px-4 rounded transition-colors duration-200"
              >
                Got it!
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;